var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldDino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 133,
    viewBox: "0 0 110 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.908 83.374c4.588 5.487 10.59 8.176 15.141 6.539a8.604 8.604 0 003.304-2.086c.15-2.306.74-6.421 2.704-8.938 1.082.767 2.961 4.88 2.961 4.88s2.367-2.647 5.19-2.538c.279 2.248-1.878 5.593-1.878 5.593 1.85.073 3.655.581 5.271 1.484-2.774 3.426-8.3 3.82-8.3 3.82-1.155 1.657-6.255 8.518-15.219 10.18-3.757.631-7.61.383-11.256-.725-2.806-.813-5.253-1.524-7.352-3.706-3.03-3.155-4.615-8.596-2.55-12.907.384-.861 2.189-4.375 5.802-4.71 2.067-.217 4.23.867 6.182 3.114z",
    fill: "#6F568E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.127 85.549a2.276 2.276 0 011.088 3.013 2.262 2.262 0 01-3.393.86 2.265 2.265 0 012.305-3.873z",
    fill: "#FFC500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.625 103.505c-7.097-.91-13.284 1.171-15.56 5.472a8.674 8.674 0 00-.964 3.771c1.462 1.821 3.825 5.223 4.074 8.409-1.311.162-5.418-1.582-5.418-1.582s0 3.565-2.091 5.418c-1.734-1.452-2.417-5.418-2.417-5.418a11.767 11.767 0 01-4.908 2.503c-.293-4.399 3.5-8.441 3.5-8.441-.271-2.005-1.181-10.511 4.334-17.836a24.63 24.63 0 018.744-7.097 17.553 17.553 0 018.67-1.853 10.391 10.391 0 019.751 7.39c.26.9 1.366 4.692-1.083 7.401-1.355 1.506-3.674 2.188-6.632 1.863z",
    fill: "#6F568E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1 79.742l-9.395-6.263 6.263-7.823-9.59-7.044 8.81-9.752-12.526-7.585 11.92-9.59L25.1 79.743z",
    fill: "#0D1013"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 59.54a99.95 99.95 0 01-1.179 11.178c-3.093 18.712-.93 23.648-5.862 45.137-1.583 3.145.649 2.249 0 3.145H21.687c4.63-5.176 4.326-11.944 3.959-17.249A2463.06 2463.06 0 0020 30s1.58.289 4.142.876c6.338 1.433 18.722 4.698 28.824 10.092C57.433 43.387 68 59.541 68 59.541z",
    fill: "#FF6170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.361 42.01h-.118c-16.308-.384-20.398 11.363-11.99 13.64 0 0 2.849 44.162 2.298 53.976-.42 7.497-2.674 9.374-2.674 9.374h20.916c2.846-3.635 1.002.111 1.346-4.34 2.277-20.138 5.396-47.4 5.396-47.4 0-.255.097-.982.173-1.963.216-2.66.291-4.642.291-4.72.076-2.473-6.28-9.853-15.638-18.568z",
    fill: "#FFC500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.488 42.229C84.209 27.48 70.166 27.34 48.397 28.489c-8.322.444-28.173 1.376-28.173 1.376 1.517 10.901 6.328 17.543 8.538 20.957 12.884 19.873 38.522 17.521 39.638 17.5 5.623-.141 15.44-.89 16.6-1.084a106.974 106.974 0 00.488-25.01z",
    fill: "#FF6170"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.355 24.122c3.25.802 4.908 4.952 3.64 9.265-1.267 4.313-4.962 7.151-8.246 6.35-3.283-.802-4.908-4.952-3.64-9.265 1.267-4.313 4.962-7.152 8.246-6.35z",
    fill: "#FF6170"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.301 28.067c1.149.552 1.441 2.503.65 4.334-.79 1.831-2.362 2.915-3.51 2.362-1.15-.552-1.442-2.503-.65-4.334.79-1.831 2.362-2.915 3.51-2.362z",
    fill: "#0D1013"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.43 30.851c2.47 1.68 2.34 5.667-.304 8.918-2.644 3.25-6.794 4.53-9.275 2.85-2.482-1.68-2.33-5.656.314-8.907 2.644-3.25 6.794-4.486 9.265-2.86z",
    fill: "#FF6170"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.565 33.636c.889.748.65 2.384-.542 3.652-1.191 1.268-2.85 1.69-3.738.943-.888-.748-.64-2.384.542-3.652 1.181-1.268 2.86-1.69 3.738-.943z",
    fill: "#0D1013"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.128 12.788a12.06 12.06 0 11-.022 24.12 12.06 12.06 0 01.022-24.12z",
    fill: "#6F568E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.235 11.715a12.06 12.06 0 11-.022 24.122 12.06 12.06 0 01.022-24.122z",
    fill: "#6F568E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.128 17.1a7.747 7.747 0 11-7.791 7.792 7.759 7.759 0 017.79-7.791z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.128 21.186a3.663 3.663 0 11-.001 7.326 3.663 3.663 0 010-7.326z",
    fill: "#0D1013"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.235 16.017a7.758 7.758 0 11-7.759 7.791 7.77 7.77 0 017.759-7.79z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.235 20.113a3.663 3.663 0 110 7.327 3.663 3.663 0 010-7.327z",
    fill: "#0D1013"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.563 58.2l-.455 8.865 9.243-2.373 3.153 8.116 8.387-4.291L58.79 75.7l6.794-5.917-2.47-.888-11.974-2.113-9.47-3.273-8.106-5.31z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.012 5.77s-1.701-.618-5.172 1.185c-3.471 1.802-4.213 6.13-10.573 6.985-6.359.853-6.85-2.23-4.954-3.558 3.619-2.609 6.427-.996 6.427-.996s-2.808-1.08-3.619-2.3c-1.256-1.85-.514-3.072.81-3.843 3.848-2.23 8.575.996 8.575.996s-2.215-2.3.742-3.071c3.277-.818 7.764 4.601 7.764 4.601zM42.513 5.684s1.5-.9 5.141.3c3.64 1.199 4.998 5.072 11.209 4.842 6.21-.23 6.078-3.355 4.148-4.254-3.862-1.856-6.289.15-6.289.15s2.505-1.487 3.078-2.836c.927-2.006 0-3.055-1.434-3.574-3.993-1.418-7.998 2.456-7.998 2.456S52.078.162 49.265.012c-3.398-.23-6.752 5.672-6.752 5.672zM85.929 61.915a21.97 21.97 0 01-7.198-6.652c-7.569 4.342-14.003 12.115-21.722 11.884-6.214-.138-17.451-4.781-22.844-10.834-23.295 49.423 31.014 69.751 43.976 75.884-4.04-8.674-4.86-19.219-4.86-19.219 0 2.171 5.392 5.393 5.392 5.393.451-10.475 6.735-17.948 8.691-32.825a55.486 55.486 0 00-1.435-23.63z",
    fill: "#C5C7D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.138 58.976c-.595-4.202-5.784-4.203-9.484-3.076-2.75.824-5.12 2.484-8.454 4.957-4.376 3.228-8.018-1.73-8.018-1.73s.664 7.744 9.782 8.951c9.118 1.208 16.92-3.61 16.174-9.102z",
    fill: "#777B8B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.378 59.486c1.31-4.345 5.182-4.865 8.546-3.663 2.043.74-1.829 1.94-1.242 2.392.587.45 2.258 8.967 2.258 8.967-5.791-.07-10.803-3.582-9.562-7.696z",
    fill: "#777B8B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.493 55.38c1.263-4.58 5.281-5.128 8.702-3.861 2.078.78 3.11 1.96 5.648 4.02 3.639 2.996 9.184-1.426 9.184-1.426s-1.63 8.357-9.058 10.33c-7.634 2.046-16.553-1.498-14.475-9.063z",
    fill: "#C5C7D4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.79 55.71c-1.46-3.654-5.127-4.283-8.794-3.253-2.704.77-5.047 2.32-8.352 4.629-4.323 3.025-11.713-.282-11.713-.282a13.005 13.005 0 004.483 5.527 13.836 13.836 0 006.834 2.474c9.19 1.15 20.179-2.504 17.542-9.096z",
    fill: "#C5C7D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.373 69.349c-10.936-.142-33.46-4.121-36.67-16.102v-.076a.922.922 0 01.121-.714.957.957 0 01.605-.42.998.998 0 01.733.118.96.96 0 01.433.588c1.61 5.886 8.75 9.438 14.506 11.356a68.607 68.607 0 0020.418 3.288c0 .263-.146 1.841-.146 1.962z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.58 63.026l9.83 3.422 12.352 2.246 2.59.936-7.064 6.22-5.028-7.54-8.689 4.503-3.285-8.55-9.525 2.497.46-9.33 8.359 5.596z",
    fill: "#fff"
  })));
}
export default SvgOldDino;